const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://backend-371609937526.us-central1.run.app'
  : 'http://localhost:8080';

export default API_BASE_URL;